import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuardGuard } from './core/auth/guards/auth-guard.guard';
import { NoAuthGuardGuard } from './core/auth/guards/no-auth-guard.guard';
import { AffiliateRedirectionComponent } from './modules/auth/affiliate-redirection/affiliate-redirection.component';
import { ForcedLogoutGuardGuard } from './core/auth/guards/forced-logout.guard';
import { GetQrOrderDetailsComponent } from './modules/get-qr-order-details/get-qr-order-details.component';
import { DistributionPartnerComponent } from './modules/distribution-partner/distribution-partner.component';
import { OrderTrackingComponent } from './modules/order-tracking/order-tracking.component';
import { SpecificOrderTrackingComponent } from './modules/specific-order-tracking/specific-order-tracking.component';
import { PublicGuard } from './core/auth/guards/public.guard';

export const appRoutes: Routes = [
  {
    path: 'auth',
    canActivate: [NoAuthGuardGuard],
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'get-qr-order-details/:orderId/:dropId',
    component: GetQrOrderDetailsComponent,
    canActivate: [NoAuthGuardGuard],
  },
  {
    path: 'distribution-partner/order-details',
    canActivate: [NoAuthGuardGuard],
    component: DistributionPartnerComponent,
  },
  {
    path: 'inter-regional-order-tracking/order-details',
    // canActivate: [NoAuthGuardGuard],
    component: OrderTrackingComponent,
  },

  {
    path: 'inter-state-order-tracking/order-details',
    // canActivate: [NoAuthGuardGuard],
    component: OrderTrackingComponent,
  },

  {
    path: 'inter-regional-drop-tracking/order-details',
    // canActivate: [NoAuthGuardGuard],
    component: SpecificOrderTrackingComponent,
  },

  {
    path: 'inter-state-drop-tracking/order-details',
    // canActivate: [NoAuthGuardGuard],
    component: SpecificOrderTrackingComponent,
  },

  {
    path: 'track-order/:dropTrackId',
    loadChildren: () =>
      import('./modules/shopify-order-tracking/shopify-order-tracking.module').then(
        (m) => m.ShopifyOrderTrackingModule,
      ),
    canActivate: [PublicGuard],
    // This endpoint must be accessible without login.
  },

  {
    path: 'affiliate-redirection/:affiliateId',
    component: AffiliateRedirectionComponent,
    canActivate: [ForcedLogoutGuardGuard],
  },
  {
    path: '',
    canActivate: [AuthGuardGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./layout/layout.module').then((m) => m.LayoutModule),
      },
    ],
  },
  { path: '', pathMatch: 'full', redirectTo: 'auth' },
  {
    path: '**',
    redirectTo: '/',
  },

  // {
  //     path: 'auth',
  //     canActivate: [NoAuthGuardGuard],
  //     loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  // },
  // {
  //     path: 'affiliate-redirection/:affiliateId', component: AffiliateRedirectionComponent,
  //     canActivate: [ForcedLogoutGuardGuard],
  // },
  // { path: '', pathMatch: 'full', redirectTo: 'auth' },
  // {
  //     path: '',
  //     canActivate: [AuthGuardGuard],
  //     children: [
  //         { path: '', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule) }
  //     ],
  // },
  // {
  //     path: '**', redirectTo: '/',
  // }
];
